// Visible, keyboard-reachable counterpart to a native app's right-click menu.
// Each consumer supplies its own onClick descriptor via openAppContextMenu.

export const AppContextMenuButton = {
  tag: 'button',
  type: 'button',
  minWidth: 'controlHCompact',
  minHeight: 'controlHCompact',
  padding: '0 Z',
  round: 'radiusPill',
  borderWidth: '0',
  background: 'transparent',
  color: 'caption',
  cursor: 'pointer',
  fontSize: 'A',
  fontWeight: '700',
  letterSpacing: '.08em',
  transition: '120ms defaultBezier background, 120ms defaultBezier color',
  ':hover': { background: 'hover', color: 'title' },
  ':focus-visible': { background: 'selected', color: 'title' },
  '@coarse': { minWidth: 'C', minHeight: 'C' },
  // Flat and in the FUNCTION form: a name inside `attr:` cannot follow the
  // language (I18N-CONVENTION §1). A mount site that names a narrower action
  // overrides this same flat prop.
  'aria-label': (el) => el.call('polyglot', 'workspace.sidebar.moreActions'),
  text: '···'
}
